import React from "react";
import { THEME_OPTIONS, useTheme } from "../context/ThemeContext";

const ThemeSelector = () => {
  const { theme, setTheme } = useTheme();

  return (
    <label className="flex items-center gap-1 sm:gap-2 text-xs font-medium text-[var(--color-text-muted)]">
      <span className="hidden sm:inline">Theme</span>
      <select
        value={theme}
        onChange={(event) => setTheme(event.target.value)}
        className="rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-muted)] px-1.5 py-1.5 sm:px-2 sm:py-2 text-xs font-semibold text-[var(--color-text-strong)] shadow-sm focus:border-[var(--color-border-strong)] focus:outline-none focus:ring-2 focus:ring-[var(--color-border-strong)]"
      >
        {THEME_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
};

export default ThemeSelector;


